import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip } from 'xm-spark';

import styles from './NavTooltip.module.scss';

const NavTooltip = ({ active, children, tooltipContent }) => (
  <Tooltip
    tooltipContent={tooltipContent}
    active={active}
    placement="right"
    classes={{
      arrowWrap: styles.arrowWrap,
      tooltip: styles.tooltip,
      tooltipWrap: styles.tooltipContainer,
    }}
    popperProps={{
      modifiers: [
        {
          name: 'preventOverflow',
          enabled: false,
        },
        {
          name: 'hide',
          enabled: true,
        },
      ],
    }}
  >
    {children}
  </Tooltip>
);

NavTooltip.displayName = 'NavTooltip';
NavTooltip.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
  tooltipContent: PropTypes.node.isRequired,
};

NavTooltip.defaultProps = {
  active: true,
};

export default NavTooltip;
